window.tp = window.tp || [];
tp.push(["init", function() {
  tp.pianoId.show({
    displayMode: 'inline',
    screen: 'register',
    containerSelector: '#register-form',
    loggedIn: function(data) {
    },
    loggedOut: function() {
    }
  });
}]);
